import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  
  return getRequest(`tabletErrorLog/get-list/${size || 10}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`tabletErrorLog/edit/${id}`)
}

export async function save(values) {
  return postRequest(`tabletErrorLog/save`, values)
}

export function remove(values) {
  return postRequest(`tabletErrorLog/delete`, values)
}
